import React, {FC} from "react";
import * as fa from "@fortawesome/free-solid-svg-icons"
import {Team} from "../../../lib/src/api/dto/Team"
import {useApi} from "../api/APIContext";
import {ModalFooter} from "@traas/lib/src/components/layout/ModalProvider";
import {EmployeeWorkDays} from "../api/dto";
import {Employee} from "../../../lib/src/api/dto/Employee";

export const DeleteRoosterOverrideModal: FC<{ employee: Employee, workDays: string|undefined, onFinish?: () => void }> = (props) => {
  const {deleteWorkDaysOverride} = useApi()
  const confirm = async () => {
    await deleteWorkDaysOverride(props.employee, props.workDays!) // props.workdays is always set if modal is shown.
    props.onFinish?.()
  }

  return <form>
    <p className={""}>
      <strong>Let op!</strong> Je staat op het punt om het aangepaste rooster te verwijderen.
    </p>
    <ModalFooter icon={fa.faTimes} text={"Verwijderen"} onSubmit={confirm} />
  </form>
}
